import Ready from './common/ready.es6';
import ProtectImg from './common/protectimg.es6';
import Modal from './common/modal.es6';
import ScrollFunc from './common/scrollfunc.es6';
import Accordion from './common/accordion.es6';
import BgMovie from './top/bgmovie.es6';
import Color from './top/color.es6';
import Banner from './top/banner.es6';


class Main {
    constructor() {
        this.ready = new Ready();
        this.protectimg = new ProtectImg();
        this.scrollfunc = new ScrollFunc();
        this.accordion = new Accordion();
        this.modal = new Modal();
        this.bgmovie = new BgMovie();
        this.color = new Color();
        this.banner = new Banner();

        this.scrollfunc.init();
    }
}

const main = new Main();
